import { useInView } from "react-intersection-observer";
import { Button, Loader } from '@crunchyroll/cx-web-components';
import { Fragment, useEffect } from "react";
import { useComments } from "../hooks/useComments";
import { FormattedMessage } from "react-intl";

const INFINITE_THRESHOLD = 3;

const LoadMore = ({className}) => {
  const {fetchNextPage, hasNextPage, pagesCount, isFetchingNextPage} = useComments();
  const [ref, markerInView] = useInView();

  useEffect(() => {
    if (!markerInView) return;
    fetchNextPage();
  }, [markerInView]);

  if (!hasNextPage) return null;

  if (pagesCount > INFINITE_THRESHOLD) return (
    <Fragment>
      {isFetchingNextPage && <Loader/>}
      <div className={className} ref={ref} />
    </Fragment>
  )

  const buttonTextId = pagesCount === INFINITE_THRESHOLD ? 'comment.load_all' : 'comment.load_more';
  return (
    <Button
      type="one-weak"
      className={className}
      isLoading={isFetchingNextPage}
      onClick={() => fetchNextPage()}
    >
      <FormattedMessage id={buttonTextId} />
    </Button>
  )
}

export default LoadMore;
